import { AppRouter } from './Routes'
import './App.css'
import { store } from 'app/store'

import withClearCache from './ClearCache'

const ClearCacheComponent = withClearCache(MainApp)

function App() {
  return <ClearCacheComponent />
}

function MainApp() {
  return <AppRouter />
}

export default App
